import i18n from "../i18n/index";
import moment from "moment";

const lfMapper = {
  floors(floor, floors) {
    if (floor && floors) {
      return floor + "/" + floors;
    } else if (!floor && floors) {
      return "-/" + floors;
    } else if (floor && !floors) {
      return floor + "/-";
    }
    return "-";
  },
  showNumber(status, number) {
    if (!status) {
      return number + " (" + i18n.global.t("Hidden") + ")";
    } else {
      return number;
    }
  },
  showEstateNumber(status, number) {
    if (!number) {
      return i18n.global.t("OpenELandRegister");
    } else if (!status && number) {
      return number + " (" + i18n.global.t("Hidden") + ")";
    } else if (number) {
      return number;
    }
  },
  dealType(dealType) {
    switch (dealType) {
      case "sale":
        return i18n.global.t("Sale");
      case "rent":
        return i18n.global.t("Rent");
      case "short_term_rent":
        return i18n.global.t("ShortTermRent");
      default:
        return "-";
    }
  },
  condition(condition) {
    switch (condition) {
      case "ALACRITY_NEW_BUILDING":
        return i18n.global.t("NewBuilding");
      case "ALACRITY_TYPE_UUSVIIMISTLUS":
        return i18n.global.t("NewlyDecorated");
      case "ALACRITY_RENEWED":
        return i18n.global.t("Renovated");
      case "ALACRITY_SAN":
        return i18n.global.t("EssentialRepairDone");
      case "ALACRITY_KESKMINE":
        return i18n.global.t("Satisfactory");
      case "ALACRITY_TYPE_KAP":
        return i18n.global.t("NeedsCompleteRenewal");
      case "ALACRITY_TYPE_REM":
        return i18n.global.t("NeedsDecoration");
      case "ALACRITY_READY":
        return i18n.global.t("Ready");
      default:
        return "-";
    }
  },
  ownershipForm(ownershipForm) {
    switch (ownershipForm) {
      case "PROPERTY_KORTERIOMAND":
        return i18n.global.t("ApartmentOwnership");
      case "PROPERTY_TYPES":
        return i18n.global.t("CommonOwnership");
      case "PROPERTY_ELAMUYHISTU":
        return i18n.global.t("CooperativeHousing");
      case "PROPERTY_KINNISTU":
        return i18n.global.t("ImmovableProperty");
      case "PROPERTY_VALLASASI":
        return i18n.global.t("MovableProperty");
      case "PROPERTY_BUILDING":
        return i18n.global.t("RightOfSuperficies");
      case "PROPERTY_MUNICIPAL":
        return i18n.global.t("Municipal");
      default:
        return "-";
    }
  },
  status(status) {
    switch (status) {
      case "draft":
        return i18n.global.t("Draft");
      case "active":
        return i18n.global.t("Active");
      case "free":
        return i18n.global.t("Free");
      case "archived":
        return i18n.global.t("Archived");
      case "sold":
        return i18n.global.t("Sold");
      case "rented":
        return i18n.global.t("Rented");
      case "booked":
        return i18n.global.t("Booked");
      case "expired":
        return i18n.global.t("Expired");
    }
  },
  energyLabel(energyLabel) {
    if (energyLabel === "no_certificate") {
      return i18n.global.t("NoCertificate");
    } else if (energyLabel) {
      return energyLabel.charAt(energyLabel.length - 1);
    } else {
      return "-";
    }
  },
  buildingMaterial(material) {
    switch (material) {
      case "BUILDING_MATERIAL_TYPE_KIVI":
        return i18n.global.t("StoneHouse");
      case "BUILDING_MATERIAL_TYPE_PALK":
        return i18n.global.t("LogHouse");
      case "BUILDING_MATERIAL_TYPE_PANEEL":
        return i18n.global.t("PanelHouse");
      case "BUILDING_MATERIAL_TYPE_PUU":
        return i18n.global.t("WoodenHouse");
      default:
        return "-";
    }
  },
  readiness(readiness) {
    switch (readiness) {
      case "READINESS_READY":
        return i18n.global.t("Ready");
      case "READINESS_BOX_WITH_DOORS":
        return i18n.global.t("BoxWithDoorsAndWindows");
      case "READINESS_ROOFED_BOX":
        return i18n.global.t("RoofedBox");
      case "READINESS_ROOFLESS_BOX":
        return i18n.global.t("RooflessBox");
      case "READINESS_FOUNDATION":
        return i18n.global.t("Foundation");
      default:
        return "-";
    }
  },
  limitations(limitations) {
    switch (limitations) {
      case "CONSTRAINTS_MORTGAGE":
        return i18n.global.t("InMortage");
      case "CONSTRAINTS_OTHER":
        return i18n.global.t("OtherLimitations");
      case "CONSTRAINTS_PANT":
        return i18n.global.t("Pledge");
      case "CONSTRAINTS_PROTECTED":
        return i18n.global.t("PreservedTerritory");
      case "CONSTRAINTS_RENT":
        return i18n.global.t("RentAgreement");
      case "CONSTRAINTS_DISTRESS":
        return i18n.global.t("UnderSeizure");
      default:
        return "-";
    }
  },
  estateType(estateType) {
    switch (estateType) {
      case "commercial":
        return i18n.global.t("Commercial");
      case "apartment":
        return i18n.global.t("Apartment");
      case "house":
        return i18n.global.t("House");
      case "house_part":
        return i18n.global.t("HousePart");
      case "land":
        return i18n.global.t("LandPlot");
      case "cottage":
        return i18n.global.t("SummerHouse");
      case "garage":
        return i18n.global.t("Garage");
      case "office":
        return i18n.global.t("Office");
      case "building":
        return i18n.global.t("Building");
      case "room":
        return i18n.global.t("Room");
      case "storage":
        return i18n.global.t("Storage");
      default:
        return "-";
    }
  },
  windowView(windowView) {
    switch (windowView) {
      case "street_view":
        return i18n.global.t("StreetView");
      case "courtyard_view":
        return i18n.global.t("CourtyardView");
      case "no_window":
        return i18n.global.t("NoWindow");
      default:
        return "-";
    }
  },
  dateAvailable(dateAvailable) {
    if (dateAvailable) {
      return moment(dateAvailable, "YYYY-MM-DD").format("DD.MM.YYYY");
    } else {
      return "-";
    }
  },
  expiryDate(date) {
    if (date) {
      return moment(date).format("DD.MM.YYYY");
    } else {
      return "";
    }
  },
};

export default {
  install(app) {
    app.config.globalProperties.$lfMapper = lfMapper;
    app.provide("lfMapper", lfMapper);
  },
};
